import {
  ErrorFilledIcon,
  InfoFilledIcon,
  SuccessFilledIcon,
  WarningFilledIcon,
} from '@sharedCR/coreDesignSystem/icons';
import { LOANS_ROUTING_PARAMS, LoansPaths } from 'app/configs/routesConfig/loans';
import { PipelinesPaths } from 'app/configs/routesConfig/pipelines';

import { PushNotificationSourceType, PushNotificationType } from 'constants/pushNotifications';

export const TYPE_ICON_MAP = {
  [PushNotificationType.ERROR]: ErrorFilledIcon,
  [PushNotificationType.WARNING]: WarningFilledIcon,
  [PushNotificationType.INFO]: InfoFilledIcon,
  [PushNotificationType.SUCCESS]: SuccessFilledIcon,
};

export const SOURCE_ENTITY_PATH_BUILDERS = {
  [PushNotificationSourceType.LOAN]: sourceEntityId =>
    LoansPaths.applicationManagement.generatePath({
      [LOANS_ROUTING_PARAMS.applicationId]: sourceEntityId,
    }),
  [PushNotificationSourceType.PIPELINE]: sourceEntityId =>
    PipelinesPaths.loanPipelinesById.generatePath({ id: sourceEntityId }),
};

const RIGHT_ARROW = '\u2192';

export const LEARN_MORE_LABEL = `Learn More ${RIGHT_ARROW}`;
